import React from 'react'
import usePageMeta from '../hooks/usePageMeta'
import Header from '../components/header/Header'
import Navbar from '../components/navbar/Navbar'
import Mission from '../components/mission/Mission'
import Curriculum from '../components/curriculum/Curriculum'
import TourBand from '../components/tour_band/TourBand'
import Reviews from '../components/reviews/Reviews'
import CtaBand from '../components/cta_band/CtaBand'
import Footer from '../components/footer/Footer'

export default function LandingPage() {
  usePageMeta({
    title: 'Learning In Motion Academy | Preschool & Child Care in Tamarac, FL',
    description: 'Gold Seal accredited preschool and child care in Tamarac, FL. Infants through VPK with a movement-based curriculum, open 6:30am-6:30pm.',
    path: '/',
  })

  return (
    <>
      <Navbar/>
      <Header/>
      <Mission/>
      <Curriculum/>
      <TourBand/>
      <Reviews/>
      <CtaBand/>
      <Footer/>
    </>
  )
}
